import { render, staticRenderFns } from "./EditVerifiedProduct.vue?vue&type=template&id=5dc92868&"
import script from "./EditVerifiedProduct.vue?vue&type=script&lang=js&"
export * from "./EditVerifiedProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports